const cognitoPasswordRules: { [k: string]: (value: string) => { success?: true, errorMessage?: string } } = {
   uppercaseChar: (value) => /[A-Z]/.test(value)
      ? { success: true }
      : { errorMessage: 'Must contain an uppercase letter' },
   lowercaseChar: (value) => /[a-z]/.test(value)
      ? { success: true }
      : { errorMessage: 'Must contain a lowercase letter' },
   number: (value) => /[0-9]/.test(value)
      ? { success: true }
      : { errorMessage: 'Must contain a number' },
   specialChar: (value) => /[$^*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ]/.test(value)
      ? { success: true }
      : { errorMessage: 'Must contain a special character' },
   allowedChars: (value) => /^[A-Za-z0-9$^*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ]{8,256}$/.test(value)
      ? { success: true }
      : { errorMessage: 'Must be 8-256 characters long' },
   leadingOrTrailiningSpace: (value) => /^(?:\S.*\S|\S|\s*)$/.test(value)
      ? { success: true }
      : { errorMessage: 'Must not start or end with spaces' },
}

export default cognitoPasswordRules